var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    id: "wind-alt",
    className: "icon glyph",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,13H3a1,1,0,0,1,0-2H16a1,1,0,0,1,0,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,22a1,1,0,0,1,0-2,1.5,1.5,0,0,0,0-3H3a1,1,0,0,1,0-2H17.5a3.5,3.5,0,0,1,0,7Zm-5-13H3A1,1,0,0,1,3,7h9.5a1.5,1.5,0,0,0,0-3,1,1,0,0,1,0-2,3.5,3.5,0,0,1,0,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.aa09b3e88c591f88c038f49e23c976a3.svg";
export { ForwardRef as ReactComponent };